import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import nfcAuthService from "../services/nfcAuthService";
import UserPanelLoader from "../userPanel/components/UserPanelLoader";


export default function Dashboard() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    // Verificar si hay sesión activa
    if (!nfcAuthService.isAuthenticated()) {
      // No hay token, redirigir a página de inicio
      navigate('/');
      return;
    }

    const userData = nfcAuthService.getUserData();
    if (!userData?.id) {
      // Token inválido o sin datos
      navigate('/');
      return;
    }

    setAuthenticated(true);
    setLoading(false);
  }, [navigate]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }

  if (!authenticated) {
    return null;
  }

  // Renderizar el UserPanel pero sin necesidad de ?doc=
  // porque ya sabemos quién es el usuario por el token
  return <UserPanelLoader />;
}